type LogLevel = 'info' | 'warn' | 'error' | 'debug';

class Logger {
  private static formatMessage(level: LogLevel, message: string, data?: any): string {
    const timestamp = new Date().toISOString();
    return `[${timestamp}] [${level.toUpperCase()}] ${message}${data ? '\n' + JSON.stringify(data, null, 2) : ''}`;
  }

  static info(message: string, data?: any) {
    if (process.env.NODE_ENV === 'development') {
      console.info(this.formatMessage('info', message, data));
    }
  }

  static warn(message: string, data?: any) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(this.formatMessage('warn', message, data));
    }
  }

  static error(message: string, error?: any) {
    if (process.env.NODE_ENV === 'development') {
      console.error(this.formatMessage('error', message, error));
      if (error?.stack) {
        console.error(error.stack);
      }
    }
  }

  static debug(message: string, data?: any) {
    if (process.env.NODE_ENV === 'development') {
      console.debug(this.formatMessage('debug', message, data));
    }
  }
}

export default Logger;
